module.exports = __webpack_public_path__ + "img/gear-logo.e52b9e69.svg";